import { Injectable } from '@angular/core';
import { ValidatorInput } from '../model.module/validation/validation-descriptor.entity';

@Injectable({
    providedIn: 'root'
})
export class DateUtilsService {

    private static supportsDateInput: boolean;

    constructor() {
    }

    convertDateToGermanStr(date: Date) {
        if (!date || !(date instanceof Date)) {
            return null;
        }

        return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    }

    convertInputDate2ReadableDate(validatorInput: ValidatorInput, newValue: any): void {
        // Wird benoetigt falls der Browser den input type date nicht unterstuetzt
        if (!this.isSupportingDateInput()) {
            validatorInput.value = newValue;
            return;
        }
        const dateArray = newValue.split('-');
        validatorInput.value = `${dateArray[2]}.${dateArray[1]}.${dateArray[0]}`;
    }

    convertReadableDate2InputDate(value: any): string {
        // Wird benoetigt falls der Browser den input type date nicht unterstuetzt
        if (!this.isSupportingDateInput()) {
            return value;
        }

        const dateArray = value.split('.');
        return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
    }

    private isSupportingDateInput() {
        if (DateUtilsService.supportsDateInput != null) {
            return DateUtilsService.supportsDateInput;
        }

        const inp = document.createElement('input');
        const val = 'a';
        inp.setAttribute('type', 'date');
        inp.setAttribute('value', val);
        inp.value = 'a';

        DateUtilsService.supportsDateInput = inp.value !== val;

        return DateUtilsService.supportsDateInput;
    }

}
